angular.module("richiestaPreventivo.components", []).component("richiestaPreventivo", {
  templateUrl: "ng/components/richiestaPreventivo/richiestaPreventivo.view.html",
  bindings: {
    model: "=",
    onStructureChanges: "&",
    snapshot: '<'
  },
  controllerAs: "richiestaPreventivoCtrl",
  controller: function RichiestaPreventivo(
    $location,
    $financialApiService,
    FinancialModel,
    Riferimenti,
    $configService
  ) {
    var self = this;

    self.$onInit = function () {
      if (!self.snapshot) {
        self.model = FinancialModel.build()
      }
      self.populateContacts = 0;
      self.prodotto = "";
      self.amount = 0;
      //albaInit();
      if (!self.snapshot) {
        self.setContacts();
      }

      self.CfNsil = true;
      self.showHideSearchFilialeVariable = false;
      if (!$configService.getAppConfig().allFunctionalities.includes("RICH_PREV_RICERCA_FILIALI")) {
        self.validityComponentSearchFilialeVariable = true;
      }
      self.showAlert = false;
    }

    self.next = function () {
      self.enabledLoader = true;
      if (self.model.financialVendor && self.model.financialVendor.filiale && self.model.financialVendor.filiale.cab && self.model.financialVendor.filiale.cab.name) {
        self.model.financialVendor.filiale.cab = self.model.financialVendor.filiale.cab.name;
      }
      $financialApiService
        .submitRichiestaPreventivo(FinancialModel.build(self.model))
        .then(function (response) {
          console.log("response", response);

          if (response.success) {
            $location.path("/");
          }
        })
        .catch(function (error) {
          console.log("ERROR:", error);
        })
        .finally(function () {
          self.enabledLoader = false;
        })
    }

    self.setContacts = function () {
      self.customer = Riferimenti.build({
        id: "CLIENTE"
      })
      self.bank = Riferimenti.build({
        id: "BANCA"
      })
      self.model.leasingData.preventivo.contatti.riferimenti = [self.customer, self.bank];
    }

    self.handleStructureChange = function (finContactsStructure) {
      console.log(finContactsStructure);
    }

    self.exportProduct = function (exportProduct) {
      self.prodotto = exportProduct;
    }

    self.getCustomer = function (model) {
      var user = {};
      if (model && model.riUserG && (model.riUserG.ndg || model.riUserG.piva) && model.riUserG.cf && model.riUserG.ragioneSociale) {
        user = model.riUserG;
      } else if (model && model.riUserF && model.riUserF.cf) {
        user = model.riUserF;
        self.isPersonaFisica = true;
      }
      if ((user && !user.cf && !user.piva) || (self.isPersonaFisica && (user.nome === "" || user.cognome === ""))) {
        return
      }
      $financialApiService
        .getContattiCliente(user)
        .then(function (response) {
          console.log("getContacts_customer: ", response);
          if (response && response.riferimenti && response.riferimenti[0]) {
            self.model.leasingData.preventivo.contatti.riferimenti.forEach(function (element) {
              if (element.id == "CLIENTE") {
                element.description = response.riferimenti[0].description;
                element.email = response.riferimenti[0].email;
                element.telefono = response.riferimenti[0].telefono;
              }
            });
            self.populateContacts = self.populateContacts + 1;
          }
        }).catch(function (error) {
          console.error(error);
        });
    }

    self.getBank = function () {
      if (!$configService.getAppConfig().allFunctionalities.includes("RICH_PREV_RICERCA_FILIALI") || !self.showHideSearchFilialeVariable) {
        $financialApiService
          .getContatti($configService.getUser().ndg)
          .then(function (resp) {
            if (resp && resp.riferimenti && resp.riferimenti[0]) {
              self.riferimentiBank = resp.riferimenti[0];
            } else {
              self.riferimentiBank = [];
            }
            self.populateBank()
          })
          .catch(function (error) {
            console.error(error)
          })
      } else {
        if (!self.model.financialVendor.filiale.cab.id) {
          return;
        }
        $financialApiService
          .getContatti(self.model.financialVendor.filiale.cab.id)
          .then(function (response) {
            if (response && response.riferimenti && response.riferimenti[0]) {
              self.riferimentiBank = response.riferimenti[0]
              self.populateBank()
            }
          })
      }
    }

    self.populateBank = function () {
      self.model.leasingData.preventivo.contatti.riferimenti.forEach(function (element) {
        if (element.id == "BANCA") {
          element.description = self.riferimentiBank.description;
          element.email = self.riferimentiBank.email;
          element.telefono = self.riferimentiBank.telefono;
        }
      });
      self.populateContacts = self.populateContacts + 1;
    }

    self.exportAmount = function (exportAmount) {
      self.amount = exportAmount;
    }

    self.exportValidityCustomerDigital = function (validity) {
      if (self.snapshot) {
        return;
      }
      self.customerDigitalComponentValidity = validity;
      if (validity && self.CfNsil) {
        // self.populateContacts = 0;
        var model = self.model.financialCustomer.metadata;
        if ((self.tempModel && self.tempModel.riUserG && self.tempModel.riUserG.ndg) || (self.tempModel && self.tempModel.riUserF && self.tempModel.riUserF.cf)) {
          model = self.tempModel
        }
        self.getCustomer(model);
      }
    }

    self.exportValidityProductData = function (validity) {
      self.productDataComponentValidity = validity;
    }

    self.exportValidityBeneInLeasing = function (validity) {
      self.beneInLeasingComponentValidity = validity;
    }

    self.exportValidityDatiFinanziari = function (validity) {
      self.datiFinanziariComponentValidity = validity;
    }

    self.exportValidateCf = function (validity) {
      self.CfNsil = validity;
    }

    // self.validityCustomer = function (validity) {
    //   self.customerComponentValidity = validity
    // }

    // self.validityBank = function (validity) {
    //   self.bankComponentvalidity = validity;
    // }

    self.percentagesResetted = function (showAlert) {
      self.showAlert = showAlert;
    }

    self.validateContact = function (validation) {
      self.isContact = validation;
    }

    self.validityComponentSearchFiliale = function (value) {
      self.validityComponentSearchFilialeVariable = value;
    }

    self.checkValidity = function () {
      if (self.customerDigitalComponentValidity &&
        self.productDataComponentValidity &&
        self.beneInLeasingComponentValidity &&
        self.datiFinanziariComponentValidity &&
        self.isContact &&
        self.validityComponentSearchFilialeVariable
      ) {
        return true;
      }
      return false;
    }

    self.showHideSearchFiliale = function (value) {
      self.showHideSearchFilialeVariable = value;
      if (!self.showHideSearchFilialeVariable) {
        self.getBank()
      }
      if (!self.showHideSearchFilialeVariable) {
        self.validityComponentSearchFilialeVariable = true;
      }
    }

    self.exportModel = function (model) {
      self.tempModel = model;
      self.getCustomer(self.tempModel);
    }
  }
})